import { render, staticRenderFns } from "./industryDynamicsDelivery.vue?vue&type=template&id=7904800f&scoped=true&"
import script from "./industryDynamicsDelivery.vue?vue&type=script&lang=js&"
export * from "./industryDynamicsDelivery.vue?vue&type=script&lang=js&"
import style0 from "./industryDynamicsDelivery.vue?vue&type=style&index=0&id=7904800f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7904800f",
  null
  
)

export default component.exports